import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useLinkToDisplayWebContent = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, onsiteSegmentId: string) => {
      dispatch({
        type: 'LINK_SEND_EMAIL_TO_DISPLAY_WEB_CONTENT',
        payload: {
          id,
          onsiteSegmentId,
        },
      });
    },
    [dispatch],
  );
};
